import { Container } from './styles'

export const TextSeparator = ({ children }: { children: React.ReactNode }) => (
  <Container role="separator">{children}</Container>
)
